import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box } from 'edenred-ui';

import { IErrorResponse } from '@epi-models/containers/ErrorData';

import { ErrorDataItem } from './ErrorDataItem';
import './ErrorDetails.scss';

export const ErrorDetails = ({ error }: IErrorResponse) => {
  const { t } = useTranslation();
  const { gray5 } = useTheme();

  return (
    <Box bgcolor={gray5} padding={2} mt={1}>
      <div className="error-details-row-no-padding">
        <span>{t('components.error_popup.details')}:</span>
      </div>
      {error?.content?.errors.map(ed => (
        <ErrorDataItem
          errorData={ed}
          key={ed.key}
          className="error-details-row-no-padding"
        />
      ))}
    </Box>
  );
};
